// test1149
(1149 && 0);
